function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  d: "M.886 5.24L7 0v12L.886 6.76a1 1 0 010-1.52z",
  fill: "#212121"
}), React.createElement("path", {
  d: "M7 0v1L1.2 6 7 11v1L.886 6.76a1 1 0 010-1.52L7 0z",
  fill: "#757575"
}));

var SvgArrowRight = function SvgArrowRight(props) {
  return React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='7px' height='12px' viewBox='0 0 7 12' xmlns='http://www.w3.org/2000/svg' %3E %3Cg stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'%3E %3Cg transform='translate(3.500000, 6.000000) rotate(90.000000) translate(-3.500000, -6.000000) translate(-2.500000, 2.500000)'%3E %3Cpath d='M6.7592566,0.349226756 L12,6.46342739 L-8.52651283e-14,6.46342739 L5.2407434,0.349226756 C5.60016555,-0.0700990862 6.23146553,-0.118660623 6.65079137,0.240761528 C6.68967018,0.27408622 6.72593191,0.310347949 6.7592566,0.349226756 Z' fill='%23212121' transform='translate(6.000000, 3.231714) rotate(180.000000) translate(-6.000000, -3.231714) ' /%3E %3Cpath d='M0,-1.22124533e-13 L1,6.15771224e-14 L6,5.8 L11,-3.02737051e-14 L12,-1.22124533e-13 L6.7592566,6.11420063 C6.39983445,6.53352647 5.76853447,6.58208801 5.34920863,6.22266586 C5.31032982,6.18934117 5.27406809,6.15307944 5.2407434,6.11420063 L0,-1.22124533e-13 Z' fill='%23757575' /%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgArrowRight as ReactComponent };